import * as React from 'react';
import { DataTable } from 'react-native-paper';
import { StyleSheet, View, Text, ImageBackground } from 'react-native';
import { COLORS, FONTS, IMAGES, SIZES } from '../constants';
import { MaterialIcons } from '@expo/vector-icons';

const Evaluation = (props) => {

  const evaluationData = require('../../assets/json/evaluation.json')

  const pointer = props.category;

  return (
    <View style={styles.container}>
      <DataTable style={{
        color: COLORS.primary,
        borderBottomWidth: 0,
      }}>
        <DataTable.Header>
          <DataTable.Title>Punktacja</DataTable.Title>
          <DataTable.Title>Ocena</DataTable.Title>
          <DataTable.Title></DataTable.Title>
        </DataTable.Header>

        <DataTable.Row>
          <DataTable.Cell>{evaluationData[pointer].evaluation.a.score}</DataTable.Cell>
          <DataTable.Cell>{evaluationData[pointer].evaluation.a.rating}</DataTable.Cell>
          <DataTable.Cell style={{ flex: 0.3 }} numeric>{evaluationData[pointer].evaluation.a.num}</DataTable.Cell>
        </DataTable.Row>

        <DataTable.Row>
          <DataTable.Cell>{evaluationData[pointer].evaluation.b.score}</DataTable.Cell>
          <DataTable.Cell>{evaluationData[pointer].evaluation.b.rating}</DataTable.Cell>
          <DataTable.Cell style={{ flex: 0.3 }} numeric>{evaluationData[pointer].evaluation.b.num}</DataTable.Cell>

        </DataTable.Row>

        <DataTable.Row>
          <DataTable.Cell>{evaluationData[pointer].evaluation.c.score}</DataTable.Cell>
          <DataTable.Cell >{evaluationData[pointer].evaluation.c.rating}</DataTable.Cell>
          <DataTable.Cell style={{ flex: 0.3 }} numeric>{evaluationData[pointer].evaluation.c.num}</DataTable.Cell>

        </DataTable.Row>

        <DataTable.Row>
          <DataTable.Cell>{evaluationData[pointer].evaluation.d.score}</DataTable.Cell>
          <DataTable.Cell >{evaluationData[pointer].evaluation.d.rating}</DataTable.Cell>
          <DataTable.Cell style={{ flex: 0.3 }} numeric>{evaluationData[pointer].evaluation.d.num}</DataTable.Cell>

        </DataTable.Row>
      </DataTable>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 30,
    backgroundColor: COLORS.background,
    marginBottom: 20

  },
  tbl: {
    color: COLORS.primary,
  },
});

export default Evaluation;